<template>
  <el-dialog :visible.sync="dialogTableVisible" width="450px">
    <el-checkbox-group v-model="checkList">
      <el-checkbox
        v-for="item in deviantList"
        :key="item.Content"
        :label="item.Id"
      >
        {{ item.Content }}</el-checkbox
      >
    </el-checkbox-group>
    <template v-slot:footer>
      <el-button class="determineBtn" @click="determineBtn">我选好了</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    deviantList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogTableVisible: false,
      checkList: [],
    };
  },
  methods: {
    determineBtn() {
      let deviantName = [];
      this.deviantList.forEach((item) => {
        if (this.checkList.includes(item.Id)) {
          deviantName.push(item.Content);
        }
      });
      console.log(deviantName);
      this.dialogTableVisible = false;
      this.$emit("addTypeSelect", deviantName);
    },
  },
};
</script>
<style scoped>
.el-checkbox {
  width: 100%;
}
.determineBtn {
  background: red;
  color: #fff;
}
</style>
